/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class IdentifyPeopleService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Identify people
     * @param requestBody The person to identify. Takes a JSON object containing names and values of person properties and traits. If the person does not exist, it creates it with these properties and traits. If it does exist, it sets the properties and traits to these values, overwriting existing values.
     * @param projectId
     * @param xProjectToken
     * @returns any Request accepted
     * @throws ApiError
     */
    public identifyPeoplePost(
        requestBody: {
            /**
             * The unique identifier for this person in your database, often a user ID or UUID.
             */
            distinctId: string;
            /**
             * The anonymous unique identifier for this person, often a user ID or UUID.
             */
            anonymousId?: string;
            /**
             * A dictionary of key-value pairs representing additional attributes for the person, such as 'email', 'name', etc.
             */
            traits?: Record<string, any> | null;
            /**
             * The email address associated with the person.
             */
            email?: string;
            /**
             * City where the person is located.
             */
            city?: string;
            /**
             * Country where the person is located.
             */
            country?: string;
            /**
             * First name of the person.
             */
            forename?: string;
            /**
             * Last name of the person.
             */
            surname?: string;
            /**
             * Region or state where the person is located.
             */
            region?: string;
            /**
             * Timezone of the person's location.
             */
            timezone?: string;
            /**
             * The IDs of the groups or organizations the person is associated with.
             */
            groups?: Array<string> | null;
        },
        projectId?: string | null,
        xProjectToken?: string | null,
    ): CancelablePromise<{
        message: {
            message: 'Request accepted';
        };
        success: boolean;
        error: any;
        result?: any;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/identify/people',
            headers: {
                'x-project-token': xProjectToken,
            },
            query: {
                'projectId': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Delete an identified person
     * @param id
     * @param projectId
     * @param xProjectToken
     * @returns any Request accepted
     * @throws ApiError
     */
    public identifyPeopleDel(
        id: string,
        projectId?: string | null,
        xProjectToken?: string | null,
    ): CancelablePromise<{
        message: {
            message: 'Request accepted';
        };
        success: boolean;
        error: any;
        result?: any;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/identify/people/{id}',
            path: {
                'id': id,
            },
            headers: {
                'x-project-token': xProjectToken,
            },
            query: {
                'projectId': projectId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Update properties and traits
     * Updates or adds properties or traits to a person. The person is created if it does not exist.
     * @param id
     * @param requestBody The person properties and traits to update. Takes a JSON object containing names and values of person properties and traits. If the person does not exist, it creates it with these properties and traits. If it does exist, it updates the provided properties and traits to these values, overwriting existing values.
     * @param projectId
     * @param xProjectToken
     * @returns any Request accepted
     * @throws ApiError
     */
    public identifyPeoplePatch(
        id: string,
        requestBody: {
            /**
             * A dictionary of key-value pairs representing additional attributes for the person, such as 'email', 'name', etc.
             */
            traits?: Record<string, any> | null;
            /**
             * The email address associated with the person.
             */
            email?: string;
            /**
             * City where the person is located.
             */
            city?: string;
            /**
             * Country where the person is located.
             */
            country?: string;
            /**
             * First name of the person.
             */
            forename?: string;
            /**
             * Last name of the person.
             */
            surname?: string;
            /**
             * Region or state where the person is located.
             */
            region?: string;
            /**
             * Timezone of the person's location.
             */
            timezone?: string;
            /**
             * The IDs of the groups or organizations the person is associated with.
             */
            groups?: Array<string> | null;
        },
        projectId?: string | null,
        xProjectToken?: string | null,
    ): CancelablePromise<{
        message: {
            message: 'Request accepted';
        };
        success: boolean;
        error: any;
        result?: any;
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/identify/people/{id}',
            path: {
                'id': id,
            },
            headers: {
                'x-project-token': xProjectToken,
            },
            query: {
                'projectId': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
}
